export enum barColor {
    UKUKHULA = '#4CAF50',
    BBD = '#FF5722',
    UNIVERSITY = '#FFC107',
}